// ************************************************************************************* //
//   ___ _____ ___  ___  **   ___ _____ ___  ___  **   ___ _____ ___  ___  **
//  / __|_   _/ _ \| _ \ **  / __|_   _/ _ \| _ \ **  / __|_   _/ _ \| _ \ **
//  \__ \ | || (_) |  _/ **  \__ \ | || (_) |  _/ **  \__ \ | || (_) |  _/ **
//  |___/ |_| \___/|_|   **  |___/ |_| \___/|_|   **  |___/ |_| \___/|_|   **
// _ _ _ _ _ _ _ _ _ _ _ _ _ _ _ _ _ _ _ _ _ _ _ _ _ _ _ _ _ _ _ _ _ _ _ _ _ _ _ _ _ _ _ //
// Do not add new action handlers to this file
// listingRecord should be hydrated once on page load and then never updated again
// Instead, please add any dynamically loaded listing values to listingExtendedRecord
// ************************************************************************************* //

import createReducer from '../utils/createReducer';

const initialState = {};

const actionHandlers = {};

export default createReducer(actionHandlers, initialState);
